/* @flow */


import _idpbase from './idpbase';
import { IDP_33ACROSS } from './idpconstants';
import { isJSONSupported } from '../utils/browserutil';
import { fetchJSON, isFetchSupported } from '../utils/fetch';
import {
  getFromStore,
  getStoredValueTS,
  saveToStore
} from '../utils/storageutils';
import { getCCPA } from '../utils/privacyutils';
import { logError } from '../utils/logger';

const _33ACROSS_ID_KEY = '33acrossId';
// const REFRESH_SECONDS = 8 * 3600;  // default
const DEFAULT_TIMEOUT_MS = 2 * 1000;

class _33acrossid extends _idpbase {
  _loadFromCache(): boolean {
    if (this._cachedID.length === 0) {
      this._cachedID = getFromStore(_33ACROSS_ID_KEY, this._storage);
      if (this._refreshInterval > 0) {
        this._idUpdateTime =
          getStoredValueTS(
            _33ACROSS_ID_KEY,
            this._refreshInterval * 60,
            this._storage
          ) || this._idUpdateTime;
      }
    }
    return this._cachedID.length > 0;
  }

  _shouldRefresh(): boolean {
    return (
      super._shouldRefresh() ||
      getStoredValueTS(
        _33ACROSS_ID_KEY,
        this._refreshInterval * 60,
        this._storage
      ) === 0
    );
  }

  _isSupported(): boolean {
    return super._isSupported() && isJSONSupported() && isFetchSupported();
  }

  _refreshID() {
    if (this._pid.length === 0) {
      return;
    }

    // set PID for IDMapping
    // Refer COM-7126
    const win = this._win;
    win._33across = win._33across || {};
    win._33across.idMappingsConfig = win._33across.idMappingsConfig || {};
    win._33across.idMappingsConfig.pid = this._pid;

    // refresh the ID here
    // now fetch it from server
    const opt = {
      data: {
        pid: this._pid,
        gdpr: 0,
        // eslint-disable-next-line camelcase
        us_privacy: getCCPA()
      },
      logPrefix: this._name,
      timeout: DEFAULT_TIMEOUT_MS,
      format: 'json'
    };
    const req = {
      credentials: 'include',
      mode: 'cors'
    };
    fetchJSON(this._url, opt, req).then(
      res => {
        const {
          succeeded = false,
          error = '',
          data: { envelope = '' } = {}
        } = res;
        if (!succeeded || error.length > 0) {
          logError(`${this._name} Failed to get userID: ${error || ''}`);
          return '';
        }

        // cache it
        saveToStore(
          {
            name: _33ACROSS_ID_KEY,
            value: envelope,
            expires: this._nExpireDays * 24 * 60 * 60
          },
          this._refreshInterval > 0,
          this._storage
        );

        this._cachedID = envelope;
        return envelope;
      },
      error => {
        logError(`${this._name} Failed to get userID: ${error || ''}`);
      }
    );
  }
}
const idp: _33acrossid = new _33acrossid(IDP_33ACROSS);
export default idp;
